import { render, staticRenderFns } from "./ZeroWeightConfirmDialog.vue?vue&type=template&id=e65c479a&scoped=true"
import script from "./ZeroWeightConfirmDialog.vue?vue&type=script&lang=js"
export * from "./ZeroWeightConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./ZeroWeightConfirmDialog.vue?vue&type=style&index=0&id=e65c479a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65c479a",
  null
  
)

export default component.exports